import { render, staticRenderFns } from "./HandleRole.vue?vue&type=template&id=12079f82&scoped=true&"
import script from "./HandleRole.vue?vue&type=script&lang=js&"
export * from "./HandleRole.vue?vue&type=script&lang=js&"
import style0 from "./HandleRole.vue?vue&type=style&index=0&id=12079f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12079f82",
  null
  
)

export default component.exports